import { render, staticRenderFns } from "./cookiesTips.vue?vue&type=template&id=6e30ee16&scoped=true"
import script from "./cookiesTips.vue?vue&type=script&lang=js"
export * from "./cookiesTips.vue?vue&type=script&lang=js"
import style0 from "./cookiesTips.vue?vue&type=style&index=0&id=6e30ee16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e30ee16",
  null
  
)

export default component.exports